


































































import { Component, Vue } from 'vue-property-decorator'
import Tabs from '@/components/Tabs/index.vue'
import SearchInput from '@/components/SearchInput/index.vue'
import { mchUserData, countRelation } from '@/api/user'
import { dissolutionRelation } from '@/api/relation'

import { formatDate } from '@/utils/tool'

interface merchantDataType {
  totalNum: number;
  supplyNum: number;
  distNum: number;
}

@Component({
  name: 'Association',
  components: {
    Tabs,
    SearchInput
  }
})
export default class Association extends Vue {
  private loading = false

  // 表格数据
  private tableData = []

  // 关联商家 统计数据
  private merchantData: merchantDataType = {
    totalNum: 0,
    supplyNum: 0,
    distNum: 0
  }

  // 当前页数
  private page = 1

  // 每页的条数
  private resultNum = 20

  // 总数
  private sizeAll = 0

  // 默认点击
  private type = 1

  private keywords = ''

  // Tabs 数据
  private get tabList () {
    return [
      // {
      //   name: `全部(${this.merchantData.totalNum})`,
      //   id: 0
      // },
      {
        name: `供应商(${this.merchantData.supplyNum})`,
        id: 1
      },
      {
        name: `分销商(${this.merchantData.distNum})`,
        id: 2
      }
    ]
  }

  // page 改变时会触发
  private currentChange (e: number) : void {
    this.page = e
    this.getMchUserData()
  }

  // 关联商家 数据统计
  private getCountRelation () {
    countRelation()
      .then(res => {
        if (res.success) {
          this.merchantData = res.data
        }
      })
  }

  // 商家列表
  private getMchUserData (autoCount?: boolean) {
    this.loading = true
    // debugger
    const params = {
      autoCount: autoCount || false,
      page: this.page,
      resultNum: this.resultNum,
      type: this.type,
      keywords: this.keywords
    }
    mchUserData(params)
      .then(res => {
        this.loading = false
        if (res) {
          if (autoCount) this.sizeAll = res.sizeAll

          const arr = res.results || []
          this.tableData = arr.map(item => {
            item.createDateStr = formatDate(item.createDate)
            return item
          })
        }
      })
  }

  // 解除串货关系
  private setDissolutionRelation (item) {
    console.log(item)
    this.loading = true
    const data = {
      dbLink: item.dbLink,
      parentMchId: item.parentMchId,
      type: item.type
    }
    dissolutionRelation(data)
      .then(res => {
        this.loading = false
        if (res.success) {
          this.$message({
            message: res.msg,
            type: 'success'
          })
          this.getMchUserData(true)
          this.getCountRelation()
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      })
  }

  mounted (): void {
    this.getCountRelation()
    this.getMchUserData(true)
  }
}
